import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_FILTERS_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';
import { filtersAction } from "../actions";

const request = data => {
    return fetch(`${ url }/get_filters`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetFilters(args) {
    const est = yield select(state => state.est);

    yield put(loadingAction(true));
    const filters = yield select(state => state.filters);

    try {
        let formData = new FormData();

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            // Копия полученных фильтров
            let filtersCopy = { ...response.filters };
            // Пробегаем по пришедшим фильтрам и расставляем флаги выбранных фильтров

            for (let i in filtersCopy) {
                filtersCopy[i].forEach(elem => {

                    if (filters[i].findIndex(el => el.id === elem.id && el.active) + 1) {
                        elem.active = true;
                    }
                });
            }

            yield put(filtersAction({
                ...filters,
                ...filtersCopy
            }));
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherGetFilters() {
    yield takeLatest(GET_FILTERS_SAGA, workerGetFilters);
}